/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface DanceDetail
 */
export interface DanceDetail {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceDetail
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    name: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceDetail
     */
    seasonId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceDetail
     */
    choreographerUserId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    choreographerName: string;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    cast: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    publicNote: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    internalNote: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DanceDetail
     */
    isArchived: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DanceDetail
     */
    lastActivityAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    routineTitle: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    choreographyStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    musicStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    musicFileName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    costumeStatus: string;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    costumeDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    costumeColor: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    costumeLink: string | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceDetail
     */
    done: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof DanceDetail
     */
    total: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Array<string>}
     * @memberof DanceDetail
     */
    missing: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DanceDetail
     */
    contractDone: boolean;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    driveFileId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DanceDetail
     */
    driveSyncedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    driveError: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    musicLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    musicFileUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    costumeImageUrl: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DanceDetail
     */
    contractSignedAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    contractSignedName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DanceDetail
     */
    choreographerEngagement: string | null;
}

/**
 * Check if a given object implements the DanceDetail interface.
 */
export function instanceOfDanceDetail(value: object): value is DanceDetail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('seasonId' in value) || value['seasonId'] === undefined) return false;
    if (!('choreographerUserId' in value) || value['choreographerUserId'] === undefined) return false;
    if (!('choreographerName' in value) || value['choreographerName'] === undefined) return false;
    if (!('cast' in value) || value['cast'] === undefined) return false;
    if (!('publicNote' in value) || value['publicNote'] === undefined) return false;
    if (!('internalNote' in value) || value['internalNote'] === undefined) return false;
    if (!('isArchived' in value) || value['isArchived'] === undefined) return false;
    if (!('lastActivityAt' in value) || value['lastActivityAt'] === undefined) return false;
    if (!('routineTitle' in value) || value['routineTitle'] === undefined) return false;
    if (!('choreographyStatus' in value) || value['choreographyStatus'] === undefined) return false;
    if (!('musicStatus' in value) || value['musicStatus'] === undefined) return false;
    if (!('musicFileName' in value) || value['musicFileName'] === undefined) return false;
    if (!('costumeStatus' in value) || value['costumeStatus'] === undefined) return false;
    if (!('costumeDescription' in value) || value['costumeDescription'] === undefined) return false;
    if (!('costumeColor' in value) || value['costumeColor'] === undefined) return false;
    if (!('costumeLink' in value) || value['costumeLink'] === undefined) return false;
    if (!('done' in value) || value['done'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('missing' in value) || value['missing'] === undefined) return false;
    if (!('contractDone' in value) || value['contractDone'] === undefined) return false;
    if (!('driveFileId' in value) || value['driveFileId'] === undefined) return false;
    if (!('driveSyncedAt' in value) || value['driveSyncedAt'] === undefined) return false;
    if (!('driveError' in value) || value['driveError'] === undefined) return false;
    if (!('musicLink' in value) || value['musicLink'] === undefined) return false;
    if (!('musicFileUrl' in value) || value['musicFileUrl'] === undefined) return false;
    if (!('costumeImageUrl' in value) || value['costumeImageUrl'] === undefined) return false;
    if (!('contractSignedAt' in value) || value['contractSignedAt'] === undefined) return false;
    if (!('contractSignedName' in value) || value['contractSignedName'] === undefined) return false;
    if (!('choreographerEngagement' in value) || value['choreographerEngagement'] === undefined) return false;
    return true;
}

export function DanceDetailFromJSON(json: any): DanceDetail {
    return DanceDetailFromJSONTyped(json, false);
}

export function DanceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DanceDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'seasonId': ApiUserTasksGetPageParameterFromJSON(json['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterFromJSON(json['choreographerUserId']),
        'choreographerName': json['choreographerName'],
        'cast': json['cast'],
        'publicNote': json['publicNote'],
        'internalNote': json['internalNote'],
        'isArchived': json['isArchived'],
        'lastActivityAt': (json['lastActivityAt'] == null ? null : new Date(json['lastActivityAt'])),
        'routineTitle': json['routineTitle'],
        'choreographyStatus': json['choreographyStatus'],
        'musicStatus': json['musicStatus'],
        'musicFileName': json['musicFileName'],
        'costumeStatus': json['costumeStatus'],
        'costumeDescription': json['costumeDescription'],
        'costumeColor': json['costumeColor'],
        'costumeLink': json['costumeLink'],
        'done': ApiUserTasksGetPageParameterFromJSON(json['done']),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
        'missing': json['missing'],
        'contractDone': json['contractDone'],
        'driveFileId': json['driveFileId'],
        'driveSyncedAt': (json['driveSyncedAt'] == null ? null : new Date(json['driveSyncedAt'])),
        'driveError': json['driveError'],
        'musicLink': json['musicLink'],
        'musicFileUrl': json['musicFileUrl'],
        'costumeImageUrl': json['costumeImageUrl'],
        'contractSignedAt': (json['contractSignedAt'] == null ? null : new Date(json['contractSignedAt'])),
        'contractSignedName': json['contractSignedName'],
        'choreographerEngagement': json['choreographerEngagement'],
    };
}

export function DanceDetailToJSON(json: any): DanceDetail {
    return DanceDetailToJSONTyped(json, false);
}

export function DanceDetailToJSONTyped(value?: DanceDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'seasonId': ApiUserTasksGetPageParameterToJSON(value['seasonId']),
        'choreographerUserId': ApiUserTasksGetPageParameterToJSON(value['choreographerUserId']),
        'choreographerName': value['choreographerName'],
        'cast': value['cast'],
        'publicNote': value['publicNote'],
        'internalNote': value['internalNote'],
        'isArchived': value['isArchived'],
        'lastActivityAt': value['lastActivityAt'] == null ? value['lastActivityAt'] : value['lastActivityAt'].toISOString(),
        'routineTitle': value['routineTitle'],
        'choreographyStatus': value['choreographyStatus'],
        'musicStatus': value['musicStatus'],
        'musicFileName': value['musicFileName'],
        'costumeStatus': value['costumeStatus'],
        'costumeDescription': value['costumeDescription'],
        'costumeColor': value['costumeColor'],
        'costumeLink': value['costumeLink'],
        'done': ApiUserTasksGetPageParameterToJSON(value['done']),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
        'missing': value['missing'],
        'contractDone': value['contractDone'],
        'driveFileId': value['driveFileId'],
        'driveSyncedAt': value['driveSyncedAt'] == null ? value['driveSyncedAt'] : value['driveSyncedAt'].toISOString(),
        'driveError': value['driveError'],
        'musicLink': value['musicLink'],
        'musicFileUrl': value['musicFileUrl'],
        'costumeImageUrl': value['costumeImageUrl'],
        'contractSignedAt': value['contractSignedAt'] == null ? value['contractSignedAt'] : value['contractSignedAt'].toISOString(),
        'contractSignedName': value['contractSignedName'],
        'choreographerEngagement': value['choreographerEngagement'],
    };
}

